(function ($) {
  $(document).ready(function () {
    if ($(".intro-with-image-cards").length > 0) {
      
    $(".intro-with-image-cards").each(function () {
      var $section = $(this);
      var $slides = $section.find(".slide-item");

      // Add class only if more than 3 slides
      if ($slides.length > 3) {
        $section.addClass("slider-active");
      }

      // Initialize slick only if slider-active
      if ($section.hasClass("slider-active")) {
        $section.find(".img-outer").slick({
          autoplay: true,
          autoplaySpeed: 1000,
          dots: true,
          arrows: false,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          cssEase: "linear",
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    });}
  });
})(jQuery);